import React, { useContext, useEffect, useRef } from "react";
import ReactDOM from "react-dom";

import { VisibleContext } from "../../../lib/util/ReactUtils";
import * as Utils from "../../../lib/util/Utils";

export interface AutoFocusProps {
	children: React.ReactNode;
	focusKey?: string;
}

const AutoFocus = (props: AutoFocusProps) => {
	const ref = useRef();
	const visible = useContext(VisibleContext);
	const { children, focusKey } = props;

	const focus = async () => {
		if (ref.current) {
			// eslint-disable-next-line
			let element = ReactDOM.findDOMNode(ref.current);
			try {
				await Utils.waitFor(() => {
					(element as any).focus({ preventScroll: true });
					return document.activeElement === element;
				});
				// eslint-disable-next-line no-empty
			} catch (e) {}
		}
	};

	useEffect(() => {
		if (visible) {
			focus();
		}
	}, [visible]);

	return (
		<>
			{React.Children.map(children, (child, index) => {
				let isFocusChild = false;
				if (focusKey === undefined && index === 0) {
					isFocusChild = true;
				} else {
					isFocusChild = (child as any)?.key === focusKey;
				}

				return isFocusChild
					? React.cloneElement(child as any, {
							ref: ref,
					  })
					: child;
			})}
		</>
	);
};

export default React.memo(AutoFocus);
